import React, { Component } from 'react';
import {Col, Row} from 'antd'
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { push } from "connected-react-router";
import { withActions } from 'actionware';
import { bindActionCreators } from 'redux';
import * as numeral from 'numeral';

import AmountCard from './allotedDisbursedCard'

import Info from '../../../components/info/info';
import '../fundingLimit.less'


@connect(
  ({ localize, funding: { action, products, lenders, newCycle } }) => ({
    translate: getTranslate(localize),
    action,
    products,
    lenders,
    newCycle,
  }),
  (dispatch) => {
    return bindActionCreators({ push }, dispatch);
  }
)
@withActions({})
class DataCard extends Component {
    render() {
    const {cardData} = this.props;
      return (
        <Row key={cardData.lender_id} type="flex" align="middle" className='data-card-container'>
          <Col span={12}>{cardData.lender_name}</Col>
          <Col span={12}>
            <AmountCard {...this.props}/>
          </Col>
        </Row>
      );
    }
  }

//TODO: Keeping the commented code as this component will be used in phase 2
// class FundStatusCard extends Component {
//   render() {
//     return (
//       <div className='fund-status-card-container'>
//         <Row>
//             <span>Compliant Funding Percentage</span>
//             <Info tooltipContent={"This is the Total amount disbursed / total loan book"} placement={"topRight"}/>
//         </Row>
//         <Row>
//           <span>RP</span>
//           <span className='fund-status-card-amount-style'>200.000.00 / 700.000.00</span>
//         </Row>
//         <Row>
//           <span className='fund-status-card-status-style'>50% used</span>
//         </Row>
//       </div>
//     );
//   }
// }
export default class FundingCard extends Component {
  render() {
    const {index, cardDetail} = this.props;
    return (
      <div className='funding-card-container'>
        <Row key = {index} className='funding-card-title'>
          <Col span={16}>{cardDetail.product_name}</Col>
          <Col span={8} className='funding-card-title-right'>
            {/* <span className={`funding-card-title-right-status ${true ? "funding-card-title-right-status-alert" : ""}`}>{usedPercent}% used</span>
            <span>{total_funding_amount && total_funding_amount !== '-' ? `Rp ${numeral(total_funding_amount).format('0,0')}` : total_funding_amount}</span> */}
            {/* <span className='funding-card-title-right-divider'>/</span> */}
            <span>RP {`${numeral(cardDetail.product_limit_snapshot).format('0,0')}`}</span>
          </Col>
        </Row>
        {/* <Row>
          <Col span={11}>`
              <FundStatusCard />
          </Col>
          <Col span={11} offset={2}>
            <FundStatusCard />
          </Col>
        </Row> */}
        {cardDetail.lenders.map((cardData) => {
          return <DataCard cardData={cardData} productID = {cardDetail.product_id}/>
        })}
      </div>
    );
  }
}